/* ============================================================
   PACKAGING OUTLET â€” THEME.JS
   Shopify Cart AJAX API + Theme, Tabs, Nav, Search
   ============================================================ */

/* ---- CART AJAX API ---- */

async function addToCart(variantId, qty) {
  try {
    var addQty = parseInt(qty) || 1;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: addQty })
    });
    if (!res.ok) {
      const err = await res.json();
      showToast(err.description || 'Could not add to cart');
      return null;
    }
    const item = await res.json();
    // Update badge from current value — skip extra /cart.js round-trip
    document.querySelectorAll('#cart-count, .cart-badge').forEach(el => {
      el.textContent = (parseInt(el.textContent) || 0) + addQty;
    });
    // Extract SKU from product_title (format: [SKU]-TITLE)
    const skuMatch = item.product_title.match(/\[([^\]]+)\]/);
    const sku = skuMatch ? skuMatch[1] : 'Item';
    const qtyText = addQty > 1 ? ` x${addQty}` : '';
    showToast(`SKU: ${sku}${qtyText} added to cart`);
    // Cart page renders line items server-side — reload so the new line shows
    if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
      window.location.reload();
    }
    return item;
  } catch {
    showToast('Could not add to cart');
    return null;
  }
}

async function changeCartItem(lineItemKey, qty) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity: parseInt(qty) })
    });
    if (!res.ok) {
      showToast('Could not update cart');
      return null;
    }
    const cart = await res.json();
    // change.js returns full cart — use item_count directly
    document.querySelectorAll('#cart-count, .cart-badge').forEach(el => {
      el.textContent = cart.item_count;
    });
    return cart;
  } catch {
    showToast('Could not update cart');
    return null;
  }
}

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('#cart-count, .cart-badge').forEach(el => {
      el.textContent = cart.item_count;
    });
    return cart;
  } catch {
    return null;
  }
}

async function reorderItems(lineItemsJson) {
  let items;
  try { items = JSON.parse(lineItemsJson); } catch { return; }
  for (const item of items) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.variant_id, quantity: item.quantity })
    });
  }
  await updateCartCount();
  window.location.href = '/cart';
}

/* ---- TOAST ---- */
function showToast(msg) {
  let t = document.getElementById('toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'toast';
    t.style.cssText = `
      position:fixed; bottom:24px; left:50%; transform:translateX(-50%) translateY(12px);
      background:#1A2B4A; color:#fff; padding:12px 22px; border-radius:10px;
      font-size:0.875rem; font-weight:600; z-index:9999; opacity:0;
      transition:all 0.25s; pointer-events:none; white-space:nowrap;
      box-shadow:0 8px 24px rgba(0,0,0,0.3); border:1px solid rgba(255,255,255,0.1);
      display:flex; align-items:center; gap:10px;
    `;
    document.body.appendChild(t);
  }
  t.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16A34A" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg> ${msg}`;
  t.style.opacity = '1';
  t.style.transform = 'translateX(-50%) translateY(0)';
  clearTimeout(t._timer);
  t._timer = setTimeout(() => {
    t.style.opacity = '0';
    t.style.transform = 'translateX(-50%) translateY(12px)';
  }, 2800);
}

/* ---- THEME ---- */
function initTheme() {
  const saved = localStorage.getItem('po_theme') || 'light';
  document.documentElement.setAttribute('data-theme', saved);
  updateThemeIcon(saved);
}

function toggleTheme() {
  const current = document.documentElement.getAttribute('data-theme') || 'light';
  const next = current === 'light' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', next);
  localStorage.setItem('po_theme', next);
  updateThemeIcon(next);
}

function updateThemeIcon(theme) {
  const icon = document.getElementById('theme-icon');
  if (!icon) return;
  if (theme === 'dark') {
    icon.innerHTML = `<circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>`;
  } else {
    icon.innerHTML = `<path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>`;
  }
}

/* ---- MOBILE NAV ---- */
function openMobileNav() {
  document.getElementById('mobile-overlay')?.classList.add('open');
  document.getElementById('mobile-drawer')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeMobileNav() {
  document.getElementById('mobile-overlay')?.classList.remove('open');
  document.getElementById('mobile-drawer')?.classList.remove('open');
  document.body.style.overflow = '';
}

/* ---- TABS ---- */
function initTabs() {
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      const container = btn.closest('.tabs-wrap');
      if (!container) return;
      container.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      container.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      const panel = container.querySelector(`#tab-${target}`);
      if (panel) panel.classList.add('active');
    });
  });
}

/* ---- SEARCH ---- */
function handleHeroSearch() {
  const input = document.getElementById('hero-search-input');
  if (!input) return;
  const q = input.value.trim();
  if (q) window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
}

function filterByTag(tag, isChecked) {
  const params = new URLSearchParams(window.location.search);
  let tags = params.getAll('filter.p.tag') || [];

  if (isChecked) {
    if (!tags.includes(tag)) {
      tags.push(tag);
    }
  } else {
    tags = tags.filter(t => t !== tag);
  }

  const baseUrl = window.location.pathname;
  const newParams = new URLSearchParams();
  tags.forEach(t => newParams.append('filter.p.tag', t));
  const newUrl = tags.length > 0 ? baseUrl + '?' + newParams.toString() : baseUrl;
  window.location.href = newUrl;
}

function initHeroSearch() {
  const input = document.getElementById('hero-search-input');
  if (!input) return;
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter') handleHeroSearch();
  });
}

/* ---- SEARCH TYPEAHEAD ----
   Shopify Predictive Search API. Note /search/suggest.json 401s under
   `shopify theme dev` — the dropdown only works on a real storefront. */
function escapeHtml(str) {
  return String(str).replace(/[&<>"']/g, c =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

function goToSearch(q) {
  window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
}

function initTypeahead(input) {
  const host = input.parentElement;
  if (!host) return;
  host.classList.add('po-ta-host');

  const panel = document.createElement('div');
  panel.className = 'po-ta-panel';
  panel.setAttribute('role', 'listbox');
  panel.hidden = true;
  host.appendChild(panel);

  let results = [];
  let active = -1;
  let timer = null;
  let controller = null;

  const close = () => { panel.hidden = true; active = -1; };

  const highlight = () => {
    [...panel.querySelectorAll('.po-ta-item')].forEach((el, i) => {
      el.classList.toggle('po-ta-active', i === active);
      if (i === active) el.scrollIntoView({ block: 'nearest' });
    });
  };

  const render = products => {
    results = products;
    active = -1;
    if (!products.length) {
      panel.innerHTML = '<div class="po-ta-empty">No matches &mdash; press Enter to search everything</div>';
      panel.hidden = false;
      return;
    }
    panel.innerHTML = products.map(p => `
      <a class="po-ta-item" role="option" href="${p.url}">
        ${p.image
          ? `<img class="po-ta-thumb" src="${p.image}&width=68" alt="" width="34" height="34" loading="lazy">`
          : '<span class="po-ta-thumb po-ta-thumb-ph"></span>'}
        <span class="po-ta-text">
          <span class="po-ta-title">${escapeHtml(p.title)}</span>
          <span class="po-ta-meta">${escapeHtml(p.vendor || '')}${p.available ? '' : ' &middot; out of stock'}</span>
        </span>
        <span class="po-ta-price">$${escapeHtml(p.price)}</span>
      </a>`).join('');
    panel.hidden = false;
  };

  const search = q => {
    if (controller) controller.abort();
    controller = new AbortController();
    fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`,
          { signal: controller.signal })
      .then(r => (r.ok ? r.json() : Promise.reject(new Error(r.status))))
      .then(data => render(data.resources.results.products || []))
      .catch(err => { if (err.name !== 'AbortError') close(); });
  };

  input.setAttribute('autocomplete', 'off');

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { close(); return; }
    timer = setTimeout(() => search(q), 180);
  });

  input.addEventListener('keydown', e => {
    const open = !panel.hidden && results.length > 0;
    if (e.key === 'ArrowDown' && open) {
      e.preventDefault();
      active = (active + 1) % results.length;
      highlight();
    } else if (e.key === 'ArrowUp' && open) {
      e.preventDefault();
      active = active <= 0 ? results.length - 1 : active - 1;
      highlight();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (open && active >= 0) {
        window.location.href = results[active].url;
      } else if (input.value.trim()) {
        goToSearch(input.value.trim());
      }
    } else if (e.key === 'Escape') {
      close();
    }
  });

  // anchors steal focus on mousedown, which would close the panel before the click lands
  panel.addEventListener('mousedown', e => e.preventDefault());
  document.addEventListener('click', e => { if (!host.contains(e.target)) close(); });
}

function initTypeaheads() {
  document.querySelectorAll('.po-search input, .hero-search-input').forEach(initTypeahead);
}

/* ---- QTY STEPPER ON PRODUCT PAGE ---- */
function initQtyStepper() {
  const dec = document.getElementById('qty-dec');
  const inc = document.getElementById('qty-inc');
  const inp = document.getElementById('qty-value');
  if (!dec || !inc || !inp) return;
  dec.addEventListener('click', () => { const v = Math.max(1, parseInt(inp.value) - 1); inp.value = v; });
  inc.addEventListener('click', () => { inp.value = parseInt(inp.value) + 1; });
}

function stepQty(inputId, delta) {
  const inp = document.getElementById(inputId);
  if (!inp) return;
  const v = Math.max(1, parseInt(inp.value) + delta);
  inp.value = v;
}


/* ---- ACCESSORIES VIEW TOGGLE ---- */
function setAccessoriesView(view) {
  const tableView = document.getElementById('accessories-table-view');
  const gridView = document.getElementById('accessories-grid-view');
  const tableBtn = document.getElementById('view-acc-table-btn');
  const gridBtn = document.getElementById('view-acc-grid-btn');
  if (!tableView || !gridView) return;
  if (view === 'grid') {
    tableView.classList.add('hidden');
    gridView.classList.add('visible');
    if (tableBtn) tableBtn.classList.remove('active');
    if (gridBtn) gridBtn.classList.add('active');
  } else {
    tableView.classList.remove('hidden');
    gridView.classList.remove('visible');
    if (tableBtn) tableBtn.classList.add('active');
    if (gridBtn) gridBtn.classList.remove('active');
  }
  localStorage.setItem('po_accessories_view', view);
}

/* ---- PARTS VIEW TOGGLE ---- */
function setPartsView(view) {
  const tableView = document.getElementById('parts-table-view');
  const gridView = document.getElementById('parts-grid-view');
  const tableBtn = document.getElementById('view-table-btn');
  const gridBtn = document.getElementById('view-grid-btn');
  if (!tableView || !gridView) return;
  if (view === 'grid') {
    tableView.classList.add('hidden');
    gridView.classList.add('visible');
    if (tableBtn) tableBtn.classList.remove('active');
    if (gridBtn) gridBtn.classList.add('active');
  } else {
    tableView.classList.remove('hidden');
    gridView.classList.remove('visible');
    if (tableBtn) tableBtn.classList.add('active');
    if (gridBtn) gridBtn.classList.remove('active');
  }
  localStorage.setItem('po_parts_view', view);
}

/* ---- ACTIVE NAV ---- */
function setActiveNav() {
  const path = window.location.pathname;
  document.querySelectorAll('.header-nav a, .sidebar-nav a, .mobile-drawer a').forEach(a => {
    const href = a.getAttribute('href') || '';
    const isActive =
      (href === '/' && path === '/') ||
      (href !== '/' && href.length > 1 && path.startsWith(href));
    if (isActive) {
      a.classList.add('active');
    } else {
      a.classList.remove('active');
    }
  });
}

/* ---- MACHINE PILL FILTER (collection page, URL-based) ---- */
function filterByPill(tagValue) {
  const base = window.location.pathname;
  if (!tagValue) {
    window.location.href = base;
  } else {
    window.location.href = `${base}?filter.p.tag=${encodeURIComponent(tagValue)}`;
  }
}

function initPillActiveState() {
  const params = new URLSearchParams(window.location.search);
  const activeTag = params.get('filter.p.tag') || '';
  document.querySelectorAll('.machine-pill').forEach(pill => {
    const val = pill.dataset.tag || '';
    if (val === '' && activeTag === '') {
      pill.classList.add('active');
    } else if (val && activeTag === val) {
      pill.classList.add('active');
    } else {
      pill.classList.remove('active');
    }
  });
}

/* ---- SCROLL ANIMATIONS ---- */
function initScrollAnimations() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-animate]').forEach(el => el.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));
}

/* ---- ONBOARDING DISMISS ---- */
function dismissOnboarding(id) {
  const el = document.getElementById(id);
  if (el) {
    el.style.transition = 'opacity 0.2s';
    el.style.opacity = '0';
    setTimeout(() => { el.style.display = 'none'; }, 220);
  }
  localStorage.setItem('po_dismissed_' + id, '1');
}

/* ---- COMPAT EXPAND (product page) ---- */
function toggleCompatModels(btn) {
  const panel = document.getElementById('compat-models');
  if (!panel) return;
  const expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!expanded));
  panel.hidden = expanded;
  const chevron = btn.querySelector('.compat-chevron');
  if (chevron) chevron.classList.toggle('rotated', !expanded);
  btn.childNodes[0].textContent = expanded ? 'View exact models ' : 'Hide exact models ';
}

/* ---- CART PAGE: QTY + REMOVE (calls Shopify then reloads) ---- */
async function cartUpdateQty(lineKey, newQty) {
  await changeCartItem(lineKey, newQty);
  window.location.reload();
}

async function cartRemoveItem(lineKey) {
  await changeCartItem(lineKey, 0);
  window.location.reload();
}

/* ---- FILTER PANEL TOGGLE (MOBILE) ---- */
function toggleFilterPanel() {
  const filterPanel = document.getElementById('filter-panel');
  const filterBtn = document.getElementById('filter-toggle-btn');
  if (!filterPanel) return;
  filterPanel.classList.toggle('expanded');
  if (filterBtn) {
    filterBtn.classList.toggle('active');
    filterBtn.textContent = filterPanel.classList.contains('expanded') ? 'Hide Filters' : 'Filters';
  }
}

/* ---- COLLECTION SEARCH ---- */
function handleCollectionSearch(e) {
  if (e.key === 'Enter') {
    performCollectionSearch();
  }
}

function performCollectionSearch() {
  const q = document.getElementById('collection-search-input')?.value.trim();
  if (q) window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
}

/* ---- ANNOUNCEMENT TIMER ---- */
function updateAnnouncementTimer() {
  const msgEl = document.getElementById('announcement-message');
  if (!msgEl) return;

  const now = new Date();
  const dayOfWeek = now.getDay(); // 0 = Sunday, 1 = Monday, 5 = Friday, 6 = Saturday
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();

  // Check if it's Monday-Friday (1-5) and between 7am-10am
  const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;
  const isBusinessHours = hours >= 7 && hours < 10;

  if (isWeekday && isBusinessHours) {
    // Show timer counting down from 3 hours
    // Timer resets at 7:00am each day
    const timerStartTime = new Date(now);
    timerStartTime.setHours(7, 0, 0, 0);

    // Calculate remaining time until 10am
    const endTime = new Date(now);
    endTime.setHours(10, 0, 0, 0);

    let remainingMs = endTime - now;
    if (remainingMs <= 0) {
      // After 10am, show alt message
      msgEl.innerHTML = 'Order now and it will ship next day.';
    } else {
      const remainingHours = Math.floor(remainingMs / (1000 * 60 * 60));
      const remainingMins = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));
      const remainingSecs = Math.floor((remainingMs % (1000 * 60)) / 1000);

      const timeStr = `${String(remainingHours).padStart(2, '0')}:${String(remainingMins).padStart(2, '0')}:${String(remainingSecs).padStart(2, '0')}`;
      msgEl.innerHTML = `<span>Order in the next</span>
        <span style="font-weight:700; color:var(--po-sky); font-variant-numeric:tabular-nums">${timeStr}</span>
        <span>for same-day express shipping</span>`;
    }
  } else {
    // Outside business hours
    msgEl.innerHTML = 'Order now and it will ship next day.';
  }
}

// Update timer every second
setInterval(updateAnnouncementTimer, 1000);

/* ---- INIT ---- */
document.addEventListener('DOMContentLoaded', () => {
  initTheme();
  updateCartCount();
  setActiveNav();
  initTabs();
  initQtyStepper();
  initHeroSearch();
  initTypeaheads();
  initPillActiveState();
  initScrollAnimations();
  updateAnnouncementTimer();

  if (document.getElementById('parts-table-view')) {
    setPartsView(localStorage.getItem('po_parts_view') || 'table');
  }

  if (document.getElementById('accessories-table-view')) {
    setAccessoriesView(localStorage.getItem('po_accessories_view') || 'table');
  }

  // Restore dismissed onboarding banners
  document.querySelectorAll('[id^="onboarding-"]').forEach(el => {
    if (localStorage.getItem('po_dismissed_' + el.id)) {
      el.style.display = 'none';
    }
  });
});
